
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]/collection/[contract]",
      function () {
        return require("private-next-pages/[chain]/collection/[contract].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[chain]/collection/[contract]"])
      });
    }
  